import React from 'react';
import {
  Box,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTheme } from '@mui/material/styles';
import { modalHeaderStyles } from './styles';
import type { ModalHeaderProps } from './types';

const ModalHeader: React.FC<ModalHeaderProps> = React.memo(
  ({ incidentTimestamp, onRefresh, onClose, isFetching }) => {
    const theme = useTheme();

    return (
      <DialogTitle sx={modalHeaderStyles.titleContainer}>
        <Box component='span'>
          Historical Temperature Data
          {incidentTimestamp && (
            <Typography
              component='span'
              variant='caption'
              sx={modalHeaderStyles.incidentCaption(theme)}
            >
              (From 2h before incident to now)
            </Typography>
          )}
        </Box>
        <Box sx={modalHeaderStyles.buttonContainer}>
          <Tooltip title='Refresh data'>
            <span>
              <IconButton
                aria-label='refresh'
                onClick={onRefresh}
                disabled={isFetching}
                sx={modalHeaderStyles.refreshButton(theme, isFetching)}
              >
                <RefreshIcon />
              </IconButton>
            </span>
          </Tooltip>
          <IconButton
            aria-label='close'
            onClick={onClose}
            sx={modalHeaderStyles.closeButton(theme)}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
    );
  },
);

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;
